import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import StickyCta from "@/pages/home/components/StickyCta";
import Contact from "@/pages/home/components/Contact";
import ServiceHero from "@/pages/ihin-seiri/components/ServiceHero";
import Reasons from "@/pages/ihin-seiri/components/Reasons";
import Items from "@/pages/ihin-seiri/components/Items";
import Pricing from "@/pages/ihin-seiri/components/Pricing";
import Flow from "@/pages/ihin-seiri/components/Flow";
import ServiceAreas from "@/components/feature/ServiceAreas";
import Faq from "@/pages/ihin-seiri/components/Faq";
import ServiceTrust from "@/components/feature/ServiceTrust";
import RelatedServices from "@/components/feature/RelatedServices";

const ihinNavItems = [
  { href: "#reasons", label: "選ばれる理由" },
  { href: "#items", label: "作業内容" },
  { href: "#pricing", label: "料金目安" },
  { href: "#flow", label: "作業の流れ" },
  { href: "#areas", label: "対応エリア" },
  { href: "#faq", label: "よくある質問" },
  { href: "#trust", label: "運営会社" },
  { href: "#related", label: "関連サービス" },
];

const relatedServices = [
  {
    title: "不用品回収",
    href: "/fuyouhin-kaisyu",
    description:
      "家具・家電・大型ゴミの回収はこちら。遺品整理後の不用品処分もまとめてお任せください。",
    icon: "ri-truck-line",
  },
  {
    title: "ゴミ屋敷清掃",
    href: "/gomi-yashiki",
    description:
      "お部屋にゴミが堆積している場合はこちら。搬出・消臭・除菌まで一気に対応します。",
    icon: "ri-home-smile-2-line",
  },
];

export default function IhinSeiriPage() {
  return (
    <div className="w-full min-w-[320px] bg-background-50 text-foreground-950">
      <Header linkPrefix="" navItems={ihinNavItems} />
      <main>
        <ServiceHero />
        <Reasons />
        <Items />
        <Pricing />
        <Flow />
        <ServiceAreas description="京都市内を中心に、京都府内の幅広いエリアへ遺品整理に伺います。遠方のご遺族様のご依頼にも対応します。" />
        <Faq />
        <ServiceTrust />
        <RelatedServices items={relatedServices} />
        <Contact />
      </main>
      <Footer linkPrefix="/" />
      <StickyCta />
    </div>
  );
}